import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 300000, // 5 minutos para operações longas
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor de erro
api.interceptors.response.use(
  response => response,
  error => {
    console.error('Erro da API:', error);
    return Promise.reject(error);
  }
);

export default api;
